import ActionTypes from "./ActionTypes";
import Dispatcher from "./Dispatcher";
import JwtStore from './JwtStore';

/**
 * Has to be a function, otherwise it'll break when the login page loads
 * (without a JWT token)
 *
 * @returns {{name: string, email: string, boutique: string}}
 */
export const feedbackCommonProperties = () => ({
  name: `${JwtStore.getUserFirstName()} ${JwtStore.getUserLastName()} (${JwtStore.getUsername()})`,
  email: JwtStore.getMail(),
  boutique: JwtStore.getStores().join(', '),
});

let closeTimeoutId = null;

export default {
  help(predefined = {}) {
    clearTimeout(closeTimeoutId);

    Dispatcher.dispatch({
      actionType: ActionTypes.MODAL_FULLSCREEN_MODAL_HELP,
      predefined: { ...feedbackCommonProperties(), ...predefined },
    });
  },

  suggestion(predefined = {}) {
    clearTimeout(closeTimeoutId);

    Dispatcher.dispatch({
      actionType: ActionTypes.MODAL_FULLSCREEN_REPORT_PROBLEM_STORE,
      predefined: { ...feedbackCommonProperties(), ...predefined },
    });
  },

  reportProblem(predefined = {}) {
    clearTimeout(closeTimeoutId);

    Dispatcher.dispatch({
      actionType: ActionTypes.MODAL_FULLSCREEN_REPORT_PROBLEM_USER,
      predefined: { ...feedbackCommonProperties(), ...predefined },
    });
  },

  user(properties = {}) {
    clearTimeout(closeTimeoutId);

    Dispatcher.dispatch({
      actionType: ActionTypes.MODAL_FULLSCREEN_USER,
      properties,
    });
  },

  glossary(properties = {}) {
    clearTimeout(closeTimeoutId);

    Dispatcher.dispatch({
      actionType: ActionTypes.MODAL_FULLSCREEN_GLOSSARY,
      properties,
    });
  },

  close() {
    clearTimeout(closeTimeoutId);

    Dispatcher.dispatch({
      actionType: ActionTypes.MODAL_FULLSCREEN_CLOSE,
    });

    // We delay the "CLOSED" state to allow the modal to animate into its closed
    // state.

    // @todo 2021-06-08 probably not the best solution but should do for now.
    closeTimeoutId = setTimeout(function() {
      Dispatcher.dispatch({
        actionType: ActionTypes.MODAL_FULLSCREEN_CLOSED,
      });
    }, 200);
  },

  search(properties = {}) {
    clearTimeout(closeTimeoutId);

    Dispatcher.dispatch({
      actionType: ActionTypes.MOBILE_MODAL_SEARCH,
      properties,
    });
  },

  toggleFilterIcon(visible) {
    clearTimeout(closeTimeoutId);

    Dispatcher.dispatch({
      actionType: ActionTypes.GLOSSARY_TOGGLE_FILTER_ICON,
      visible,
    });
  },

  news(properties = {}) {
    clearTimeout(closeTimeoutId);

    Dispatcher.dispatch({
      actionType: ActionTypes.MOBILE_MODAL_NEWS,
      properties,
    });
  },

  clearRouteUri() {
    Dispatcher.dispatch({
      actionType: ActionTypes.MODAL_FULLSCREEN_CLOSED_CLEAR_ROUTE_URI,
    });
  }

}
